<template>
  <div class="vz-tag"
    :class="tagClass"
    @click="onClick"
>
    <vz-checkbox
      v-if="canCheck"
      :modelValue="modelValue"
      :variant="variant"
      class="pr-5"
      @change="emit('change', $event)"
    />
    <label class="vz-tag-title" :class="titleClass">
      <slot>{{ text }}</slot>
    </label>
    <span
      v-if="isCanClose"
      class="mdi mdi-close vz-tag-close"
      @click.prevent.stop="onClose"
    />
  </div>
</template>

<script setup lang="ts">
import { PropType } from 'vue'
import { VzClass } from '~/types/types'
import VzCheckbox from "~/components/ui-kit/vz-checkbox.vue";

const emit = defineEmits(['close','click','change'])
const props = defineProps({
  modelValue: {
    type: [Boolean, String],
    default: false
  },
  canClose: {
    type: Boolean,
    default: false
  },
  canCheck: {
    type: Boolean,
    default: false
  },
  outline: {
    type: Boolean,
    default: false
  },
  darkClose: {
    type: Boolean,
    default: false
  },
  disabled: {
    type: Boolean,
    default: false
  },
  big: {
    type: Boolean,
    default: false
  },
  linked: {
    type: Boolean,
    default: false
  },
  text: {
    type: String,
    default: ''
  },
  variant: {
    type: String,
    default: ''
  },
  titleClass: {
    type: Object as PropType<VzClass>,
    default: () => ({})
  }
})

const isCanClose = computed((): boolean => {
  if (!props.linked) {
    return props.canClose
  }
  return false
})

const tagClass = computed((): VzClass => {
  return {
    outline: props.outline,
    linked: props.linked,
    [props.variant]: props.variant,
    disabled: props.disabled,
    'dark-close': props.darkClose,
    big: props.big
  }
})

const onClose = (): void => {
  if (!props.disabled) {
    emit('close', props.modelValue || props.text)
  }
}

const onClick = (): void => {
  if (!props.disabled) {
    emit('click', props.modelValue || props.text)
  }
}
</script>
